import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { MenuSide } from "../../components/MenuSide";
import { Button, TextField, FormControl, Autocomplete } from "@mui/material";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import {
  tokenUsuario,
  urlInformacoesListasTransmissao,
  urlAlterarListasTransmissao,
  urlApagarListasTransmissao,
  urlConsultaContatosNome,
  urlContatosListasTransmissao,
  urlAdicionarContatosListasTransmissao,
  urlRemoverContatosListasTransmissao,
} from "../../utils/constants";
import ButtonCustom from "../../components/ButtonCustom";

export default function AlterarListaTransmissao() {
  const navigate = useNavigate();
  const [nome, setNome] = useState("");
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [contatosLista, setContatosLista] = useState([]);

  const url = window.location.href;
  const urlBase = new URL(url);

  const informacoesContato = async () => {
    try {
      const response = await axios.post(urlInformacoesListasTransmissao, {
        id: urlBase.searchParams.get("id"),
        token: tokenUsuario,
      });
      return response.data;
    } catch (error) {
      return null;
    }
  };

  const consultarContatosNome = async (nomeBusca) => {
    try {
      const response = await axios.post(urlConsultaContatosNome, {
        nome: nomeBusca,
        token: tokenUsuario,
      });
      return response.data;
    } catch (error) {
      return [];
    }
  };

  const consultarContatosLista = async () => {
    try {
      const response = await axios.post(urlContatosListasTransmissao, {
        id: urlBase.searchParams.get("id"),
        token: tokenUsuario,
      });
      return response.data;
    } catch (error) {
      return [];
    }
  };

  const alterarInformacoes = async () => {
    try {
      const response = await axios.post(urlAlterarListasTransmissao, {
        nome: nome,
        id: urlBase.searchParams.get("id"),
        token: tokenUsuario,
      });
      if (response.data == 1) {
        navigate({
          pathname: "/listas_transmissao",
        });
      }
    } catch (error) {
      return null;
    }
  };

  const excluirInformacoes = async () => {
    try {
      const response = await axios.post(urlApagarListasTransmissao, {
        id: urlBase.searchParams.get("id"),
        token: tokenUsuario,
      });
      if (response.data == 1) {
        navigate({
          pathname: "/listas_transmissao",
        });
      }
    } catch (error) {
      return null;
    }
  };

  const adicionarContatoLista = async (idContato) => {
      try {
      const response = await axios.post(urlAdicionarContatosListasTransmissao, {
        id_contato: idContato,
        id_grupo: urlBase.searchParams.get("id"),
        token: tokenUsuario
      });
     console.log(response);
    } catch (error) {
      return null;
    }
    atualizarContatosLista();
  };

  const removerContatoLista = async (idContato) => {
      try {
      const response = await axios.post(urlRemoverContatosListasTransmissao, {
        id_contato: idContato,
        id_grupo: urlBase.searchParams.get("id"),
        token: tokenUsuario,
      });
      console.log(response);
    } catch (error) {
      return null;
    }
    atualizarContatosLista();
  };

  const atualizarContatosLista = async () => {
    const contatos = await consultarContatosLista();
    setContatosLista(contatos);
  };

  useEffect(() => {
    const run = async () => {
      const info = await informacoesContato();
      setNome(info.nome);
      await atualizarContatosLista();
    };
    run();
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-sm-2">
          <MenuSide />
        </div>
        <div className="col-sm-10">
          <br />
          <div className="card" style={{ marginRight: "1%" }}>
            <div className="card-header">
              <div className="row">
                <div
                  className="col-sm-8"
                  style={{ fontWeight: 700, fontSize: "25px" }}
                >
                  Alterar Lista de Transmissão
                </div>
                <div className="col-sm-4 text-end">
                  <Button
                    color={"error"}
                    variant={"contained"}
                    onClick={() => {
                      excluirInformacoes();
                    }}
                    style={{
                      color: "#111B21",
                      width: 50,
                      height: 39,
                      borderRadius: "0.5rem",
                      marginTop: "4px",
                    }}
                  >
                    <DeleteForeverOutlinedIcon style={{ color: "#ffffff" }} />
                  </Button>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                </div>
              </div>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-sm-3">
                  <h6>Nome da lista</h6>
                  <FormControl fullWidth>
                    <TextField
                      placeholder="Nome da lista"
                      onChange={(event) => {
                        event.preventDefault();
                        setNome(event.target.value);
                      }}
                      value={nome}
                      type="text"
                      InputProps={{
                        sx: {
                          height: "39px",
                          borderRadius: "0.5rem",
                          width: "100%",
                          padding: "10px",
                        },
                      }}
                      variant="outlined"
                    />
                  </FormControl>
                </div>
                <div className="col-sm-6">
                  <h6>Adicionar contato</h6>
                  <Autocomplete
                    options={options}
                    getOptionLabel={(option) =>
                      `${option.nome} - ${option.numero}`
                    }
                    loading={loading}
                    onInputChange={async (event, value) => {
                      if (value && value.length >= 2) {
                        setLoading(true);
                        const contatos = await consultarContatosNome(value);
                        setOptions(contatos);
                        setLoading(false);
                      }
                    }}
                    onChange={(event, value) => {
                      if (value) {
                        adicionarContatoLista(value.id);
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Buscar contato"
                        placeholder="Digite o nome"
                        variant="outlined"
                        sx={{
                          "& .MuiInputBase-input": {},
                          "& .MuiInputBase-root": {
                            height: "39px",
                            borderRadius: "0.5rem",
                          },
                          "& .MuiOutlinedInput-root": {
                            height: "39px",
                            padding: "10px",
                          },
                          width: "100%",
                        }}
                      />
                    )}
                  />
                </div>
              </div>

              <div className="row mt-4">
                <div className="col-sm-12">
                  <h6>Contatos da lista</h6>
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Nome</th>
                        <th>Cliente</th>
                        <th>Empresa</th>
                        <th>Número</th>
                        <th>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {contatosLista.map((contato) => (
                        <tr key={contato.id}>
                          <td>{contato.id}</td>
                          <td>{contato.nome}</td>
                          <td>{contato.cliente_nome}</td>
                          <td>{contato.empresa_nome}</td>
                          <td>{contato.numero}</td>
                          <td className="text-center">
                            <Button
                              color="error"
                              variant="contained"
                              onClick={() => removerContatoLista(contato.id)}
                              style={{
                                width: 40,
                                height: 30,
                                borderRadius: "0.5rem",
                              }}
                            >
                              <DeleteForeverOutlinedIcon
                                style={{ color: "#ffffff" }}
                              />
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="card-footer">
              <div className="row">
                <div className="col-sm-3"></div>
                <div className="col-sm-5"></div>
                <div className="col-sm-4 text-end">
                  <ButtonCustom
                    onClick={() => {
                      alterarInformacoes();
                    }}
                    color={"error"}
                    texto={"Clique para alterar o nome da lista"}
                    icon={null}
                  />
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
